// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-body[data-v-26084dc2] {\n  padding: 35px;\n}\n[data-v-26084dc2] .disabled {\n  cursor: not-allowed;\n}\nsmall[data-v-26084dc2] {\n  display: block;\n}\n.password-eye[data-v-26084dc2] {\n  right: 10px;\n  top: 15px;\n  cursor: pointer;\n}\n.is-valid ~ .password-eye[data-v-26084dc2],\n.is-invalid ~ .password-eye[data-v-26084dc2] {\n  right: 35px;\n}\n", ""]);
// Exports
module.exports = exports;
